import { mutations as types } from "./types";
import { FETCH } from "@/utils/list.js";

let comparer = (obj, item) => {
  return obj.id === item.id;
};

const mutations = {
  [types.AGENCY_UPDATE_STATUS](
    state, {
      loading = false,
      success = false,
      error = false
    }
  ) {
    state.status.loading = loading;
    state.status.success = success;
    state.status.error = error;
  },
  [types.AGENCY_FETCH_SHOP_LIST]: (state, { shops, type }) => {
    FETCH(state[type].list, shops, comparer, null);
  },
  [types.AGENCY_UPDATE_SHOP_PAGINATION]: (state, page) => {
    state.shopList.pagination.page = page;
  },
  [types.AGENCY_UNLINK_SHOP](state, { shop }) {
    if (!shop) return;
    if (!state.shopList || !state.shopList.list) {
      return;
    }
    let index = state.shopList.list.findIndex(item => item.id == shop.id);
    if (index > -1) state.shopList.list.splice(index, 1);
  },
  [types.AGENCY_CHANGE_SEARCH](state, value) {
    state.search = value;
  },
  [types.AGENCY_UPDATE_FETCHED](state) {
    state.shopList.fetched = false;
  },
  [types.AGENCY_UPDATE_AGENCY_INFO](state, data) {

    Object.keys(data).forEach(key => {
      state.info[key] = data[key];
    });
  }

};

export default mutations;
